module.exports = __webpack_public_path__ + "img/partner-list-2.68065759.png";